import { Text } from "@react-three/drei";

const RASDescription = () => {
  return (
    <Text
      position={[0, -0.99, 0]}
      rotation-x={-Math.PI / 2}
      fontSize={0.7}
      color="white"
    >
      {[
        "Role: Software Engineer",
        "Period: 2013 Jan - 2015 Aug",
        "",
        "Tech stack: C++",
        "",
        "Achievements:",
        "Software development for radiation detection equipment",
      ].join("\n")}
    </Text>
  );
};

export default RASDescription;
